/**
 * @desc 解绑
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.StagingAreaDetailAddRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/unBinding`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
